const getters = {
  img: state => state.img,
  nickname: state => state.nickname,
  userInfo: state => state.user.userInfo,
};

export default getters;
